module.exports = __webpack_public_path__ + "img/08848231003349.712361d0.png";